import { authHeader } from '../_helpers';
import { handleResponse } from '../_helpers';
import { apiClient } from '../_helpers';

export const clientService = {
  getById,
  getCurrentClient
};

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
};

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/clients/${id}`, requestOptions).then(handleResponse);
}

function getCurrentClient(slug) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/clients/${slug}`, requestOptions)
    .then(handleResponse)
    .then(client => {
        return client;
    });
}